import { createReducer } from '@reduxjs/toolkit';

import { MESSAGE_RECEIVED_FROM_SOCKET } from 'modules/websockets/actionTypes';
import { FETCH_MESSAGES_SUCCESS, FETCH_NEXT_MESSAGES_SUCCESS } from 'modules/chat/actionTypes';

/**
 * @typedef {Array<string>} DisplayedMessagesState
 */

/** @type {DisplayedMessagesState} */
const initialState = [];

const formatMessages = (messages) => messages?.map(({ id }) => id) ?? initialState;

/**
 * @param {DisplayedMessagesState} state
 * @param {import('modules/websockets/types').MessageReceivedAction} action
 * @returns {DisplayedMessagesState}
 */
const setFromSocket = (state, { payload: data }) => [data.message.id, ...state];

export default createReducer(initialState, (builder) => {
  builder
    .addCase(MESSAGE_RECEIVED_FROM_SOCKET, setFromSocket)
    .addCase(FETCH_MESSAGES_SUCCESS, (_, { payload: { messages } }) => formatMessages(messages))
    .addCase(FETCH_NEXT_MESSAGES_SUCCESS, (state, { payload: { messages } }) => {
      const seen = new Set(state);
      const newIds = formatMessages(messages).filter(id => !seen.has(id));
      return [...state, ...newIds];
    });
});
